import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Layout
import Layout from "@/components/layout/Layout";
import AdminLayout from "@/components/layout/AdminLayout";
import ScrollToTop from "@/components/common/ScrollToTop";

// Pages
import HomePage from "@/pages/HomePage";
import ShopPage from "@/pages/ShopPage";
import ProductPage from "@/pages/ProductPage";
import CartPage from "@/pages/CartPage";
import CheckoutPage from "@/pages/CheckoutPage";
import AboutPage from "@/pages/AboutPage";
import ImpactPage from "@/pages/ImpactPage";
import JournalPage from "@/pages/JournalPage";
import JournalPostPage from "@/pages/JournalPostPage";
import ContactPage from "@/pages/ContactPage";
import CraftPage from "@/pages/CraftPage";
import ArtisansPage from "@/pages/ArtisansPage";
import GiftingPage from "@/pages/GiftingPage";
import LoyaltyPage from "@/pages/LoyaltyPage";
import OrderTrackingPage from "@/pages/OrderTrackingPage";
import AccountPage from "@/pages/AccountPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import FAQPage from "@/pages/FAQPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import RefundPolicyPage from "@/pages/RefundPolicyPage";
import OrderConfirmationPage from "@/pages/OrderConfirmationPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import BecomePartnerPage from "@/pages/BecomePartnerPage";
import PartnerThankYouPage from "@/pages/PartnerThankYouPage";
import CorporateEnquiriesPage from "@/pages/CorporateEnquiriesPage";

// Admin Pages
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminCustomers from "@/pages/admin/AdminCustomers";
import AdminJournal from "@/pages/admin/AdminJournal";
import AdminLoyalty from "@/pages/admin/AdminLoyalty";
import AdminCMS from "@/pages/admin/AdminCMS";
import AdminImages from "@/pages/admin/AdminImages";
import AdminShipping from "@/pages/admin/AdminShipping";
import AdminLogin from "@/pages/admin/AdminLogin";

// Context
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import { CurrencyProvider } from "@/context/CurrencyContext";

// Styles
import "@/App.css";

function App() {
  return (
    <AuthProvider>
      <CurrencyProvider>
        <CartProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              {/* Public Routes */}
              <Route element={<Layout />}>
                <Route path="/" element={<HomePage />} />
                <Route path="/shop" element={<ShopPage />} />
                <Route path="/shop/:category" element={<ShopPage />} />
                <Route path="/product/:slug" element={<ProductPage />} />
                <Route path="/cart" element={<CartPage />} />
                <Route path="/checkout" element={<CheckoutPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/impact" element={<ImpactPage />} />
                <Route path="/journal" element={<JournalPage />} />
                <Route path="/journal/:slug" element={<JournalPostPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/the-craft" element={<CraftPage />} />
                <Route path="/artisans" element={<ArtisansPage />} />
                <Route path="/artisans/:slug" element={<ArtisansPage />} />
                <Route path="/gifting" element={<GiftingPage />} />
                <Route path="/become-a-partner" element={<BecomePartnerPage />} />
                <Route path="/partner-thank-you" element={<PartnerThankYouPage />} />
                <Route path="/corporate-enquiries" element={<CorporateEnquiriesPage />} />
                <Route path="/chaleur-club" element={<LoyaltyPage />} />
                <Route path="/track-order" element={<OrderTrackingPage />} />
                <Route path="/account" element={<AccountPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                <Route path="/reset-password" element={<ResetPasswordPage />} />
                <Route path="/faq" element={<FAQPage />} />
                <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                <Route path="/refund-policy" element={<RefundPolicyPage />} />
                <Route path="/order-confirmation/:orderNumber" element={<OrderConfirmationPage />} />
              </Route>
              
              {/* Admin Routes */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="products" element={<AdminProducts />} />
                <Route path="categories" element={<AdminCategories />} />
                <Route path="orders" element={<AdminOrders />} />
                <Route path="customers" element={<AdminCustomers />} />
                <Route path="journal" element={<AdminJournal />} />
                <Route path="loyalty" element={<AdminLoyalty />} />
                <Route path="cms" element={<AdminCMS />} />
                <Route path="images" element={<AdminImages />} />
                <Route path="shipping" element={<AdminShipping />} />
              </Route>
            </Routes>
            <Toaster position="top-center" richColors closeButton />
          </BrowserRouter>
        </CartProvider>
      </CurrencyProvider>
    </AuthProvider>
  );
}

export default App;
